var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.047,
    height: 12.038,
    viewBox: "0 0 15.047 12.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-check",
    "data-name": "Icon awesome-user-check",
    d: "M5.267,6.019A3.009,3.009,0,1,0,2.257,3.009,3.009,3.009,0,0,0,5.267,6.019Zm2.107.752H6.981a4.093,4.093,0,0,1-3.428,0H3.16A3.161,3.161,0,0,0,0,9.931v.978a1.129,1.129,0,0,0,1.129,1.129H9.4a1.129,1.129,0,0,0,1.129-1.129V9.931A3.161,3.161,0,0,0,7.373,6.771Zm7.594-3.019-.654-.661a.279.279,0,0,0-.395,0L11.455,5.535l-1.07-1.077a.279.279,0,0,0-.395,0l-.661.656a.279.279,0,0,0,0,.395l1.921,1.935a.279.279,0,0,0,.395,0l3.322-3.3a.281.281,0,0,0,0-.395Z",
    fill: "#21e270"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckinIcon);
export default __webpack_public_path__ + "static/media/checkin-icon.8f4f4695.svg";
export { ForwardRef as ReactComponent };